import { render, staticRenderFns } from "./AlphaNav.vue?vue&type=template&id=3b787fd3&"
import script from "./AlphaNav.vue?vue&type=script&lang=js&"
export * from "./AlphaNav.vue?vue&type=script&lang=js&"
import style0 from "./AlphaNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports